import React, {Component} from 'react';
import {Query} from 'react-apollo';
import {Card, Table} from 'antd';
import {Link} from 'react-router-dom';
import Auth, {Permission} from '../../../../utils/auth';

import {GET_REGIONS} from '../../graphql';
import {Region} from '../../interfaces';

interface ParsedRegion extends Region {
  key: String;
}

class SelectRegion extends Component {
  filterRegions(regions: Array<Region>, type: Permission): Array<Region> {
    const roles: Array<string> = Auth.getRoles();
    const regionRoles = roles.filter(role => role.includes('regionRole'));
    const requiredRoles = regionRoles.filter(role => role.includes(type)).map(role => role.split(':')[1]);

    if (roles.some(role => role === 'admin')) {
      return regions;
    }

    return regions ? regions.filter(({id}) => requiredRoles.some(role => role === id)) : [];
  }

  render() {
    return (
      <Query query={GET_REGIONS}>
        {({loading, error, data}: any) => {
          if (loading) {
            return <Card loading={loading} />;
          }

          if (error || !data) {
            return `Error! ${error.message} Try to refresh.`;
          }

          const {regions} = data;

          const dataSource: Array<ParsedRegion> = this.filterRegions(regions, Permission.Orders)
            .map((region: Region) => ({
              id: region.id,
              name: region.name,
              key: region.id
            }))
            .sort((a: ParsedRegion, b: ParsedRegion) => (b.name > a.name ? -1 : 1));

          const columns = [
            {
              title: 'Region',
              dataIndex: 'id',
              key: 'id',
              render: (id: String) => <Link to={`/submission-crm-errors/${id}`}>{dataSource.find((a: Region) => a.id === id).name}</Link>
            }
          ];

          return (
            <Card bodyStyle={{padding: 0}}>
              <Table style={{background: '#fff'}} dataSource={dataSource} columns={columns} pagination={false} />
            </Card>
          );
        }}
      </Query>
    );
  }
}

export default SelectRegion;



// WEBPACK FOOTER //
// ./src/pages/SubmissionCrmErrorsPage/components/SelectRegion/SelectRegion.tsx